module.exports = __webpack_public_path__ + "static/img/smart3.46fdf97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/smart/smart3.jpg
// module id = phT+
// module chunks = 1